import React, { Fragment, useContext } from 'react';
import { AppContext } from '../../context/listingsContext';
import { SelectedFilters, NumberOfResults, TopBarFilters, MachineTranslationButtonWrapper } from '../index';

const DesktopTopBar = ({ gigs, fromSearchFlow }) => {
    const { pagination, filter, isDefaultLocale } = useContext(AppContext);
    const { topBar, subCategory, selected, active } = filter;
    const { alias } = subCategory.children.find(({ selected }) => selected) || {};
    const selectedScName = fromSearchFlow && alias;
    const noGigs = gigs.length === 0;

    return (
        <Fragment>
            <TopBarFilters filters={topBar}
                selectedFilters={selected}
                activeFilters={active}
                subCategory={subCategory}
                noGigs={noGigs}
                fromSearchFlow={fromSearchFlow}/>

            <div className="selected-filters-wrapper row">
                <SelectedFilters selectedFilters={selected}
                    selectedScName={selectedScName}
                    activeFilters={active}/>
            </div>

            <div className="row top-secondary">
                <div className="results-info">
                    { !noGigs && <NumberOfResults pagination={pagination}/> }
                    { !isDefaultLocale && <MachineTranslationButtonWrapper gigsListings={[gigs]} showSeparator/> }
                </div>
            </div>
        </Fragment>
    );};

export default DesktopTopBar;
